import { Box, Typography } from "@mui/material";
import { Close, Done } from "@mui/icons-material";
import type { NotReadyForSaleReason } from "../../types";

export function ReadOnlyReadyForSaleRadio({
  isReady = false,
  reason = null,
}: {
  isReady: boolean;
  reason?: NotReadyForSaleReason | null;
}) {
  const notReadyLabel = reason
    ? `Not ready for sale - ${reason}`
    : "Not ready for sale";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "start",
        alignItems: "center",
      }}
    >
      {isReady ? (
        <>
          <Done fontSize="large" color="success" />
          <Typography variant="body1">Ready for sale</Typography>
        </>
      ) : (
        <>
          <Close fontSize="large" color="error" />
          <Typography variant="body1">{notReadyLabel}</Typography>
        </>
      )}
    </Box>
  );
}
